import { ProgressBarCalcMethodEnum } from "./RoundCalculation";
import { ProgressBarProps } from "react-bootstrap";

export const ProgressBarClass: Record<string, string> = {
    "success": 'bg-success',
    "info": 'bg-info',
    "warning": 'bg-warning',
    "danger": 'bg-danger'
};

export interface IProgressBar extends ProgressBarProps {
    variant: string,
    min: number,
    now: number,
    max: number,
    progressCalcMethod: ProgressBarCalcMethodEnum
}